import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Megaphone } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/AuthContext';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CLOSED_KEY = 'mt_marketing_consent_prompt_closed';

export const MarketingConsentPrompt = () => {
  const { token } = useAuth();
  const [consent, setConsent] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!token || sessionStorage.getItem(CLOSED_KEY)) return;
    axios.get(`${API}/marketing-consent/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then(({ data }) => setConsent(data))
      .catch(() => setConsent(null));
  }, [token]);

  if (!consent?.applicable || consent.status) return null;

  const answer = async (choice) => {
    setBusy(true);
    try {
      await axios.post(`${API}/marketing-consent`, { choice, source: 'login_prompt' }, { headers: { Authorization: `Bearer ${token}` } });
      setConsent({ ...consent, status: choice });
      toast.success(choice === 'accepted' ? 'Merci, ton choix est enregistré.' : 'Compris, tu ne recevras pas d’offres commerciales.');
    } catch (error) {
      toast.error('Ton choix n’a pas pu être enregistré. Réessaie plus tard.');
    } finally {
      setBusy(false);
    }
  };

  const later = () => {
    sessionStorage.setItem(CLOSED_KEY, '1');
    setConsent(null);
  };

  return (
    <div className="fixed inset-x-3 bottom-3 z-[2500] mx-auto max-w-lg rounded-lg border border-zinc-700 bg-[#18181B] p-4 shadow-2xl" data-testid="marketing-consent-prompt">
      <p className="mb-2 flex items-center gap-2 font-bold text-white"><Megaphone className="h-4 w-4 text-[#FFD60A]" />Offres Métro-Taxi</p>
      <p className="mb-4 text-sm text-zinc-300">{consent.text}</p>
      <div className="grid grid-cols-2 gap-2">
        <Button variant="outline" disabled={busy} onClick={() => answer('refused')} data-testid="marketing-consent-refuse-btn">Non merci</Button>
        <Button variant="outline" disabled={busy} onClick={() => answer('accepted')} data-testid="marketing-consent-accept-btn">Oui, j’accepte</Button>
      </div>
      <button type="button" onClick={later} className="mt-3 w-full text-center text-xs text-zinc-500 underline" data-testid="marketing-consent-later-btn">
        Me le demander plus tard
      </button>
    </div>
  );
};
